import { render } from "./DeliveryPage.vue?vue&type=template&id=1a2131ec&scoped=true"
import script from "./DeliveryPage.vue?vue&type=script&lang=js"
export * from "./DeliveryPage.vue?vue&type=script&lang=js"

import "./DeliveryPage.vue?vue&type=style&index=0&id=1a2131ec&lang=scss&scoped=true"
import "./DeliveryPage.vue?vue&type=style&index=1&id=1a2131ec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2131ec"]])

export default __exports__